import React from 'react';
import PropTypes from 'prop-types';
/* components */
import AuthWrapper from '../../components/auth-wrapper/auth-wrapper';

function LoggedOut(props) {
    return (
        <AuthWrapper heading="Logged out">
            <section className="sten-content__section">
                <p>You are successfully logged out from OrbitMI application.</p>
            </section>
            <div className="sten-content__separator" />
            <section className="sten-content__section">
                <a
                    className="btn btn--secondary btn--sm col-24"
                    href={`/Account/Login?returnUrl=${encodeURIComponent(props.model.postLogoutRedirectUri || '/')}`}
                >
                    Back To Login
                </a>
            </section>
        </AuthWrapper>
    );
}

LoggedOut.propTypes = {
    model: PropTypes.objectOf(PropTypes.any).isRequired
};

export default LoggedOut;
